window.addEventListener('DOMContentLoaded', () => {
	const heroVideos = document.querySelectorAll('.hero-video')
	const len = heroVideos.length

	for (let i = 0; i < len; i++) {
		let vidWrapper = heroVideos[i].querySelector('.playVid')
		let video = vidWrapper.querySelector('video')
		let vidTime = vidWrapper.querySelector('.video-button')
		let span = vidTime.querySelector('span')

		vidTime.addEventListener('click', () => {
			if (heroVideos[i].classList.contains('next-video')) {
				if (i <= 0) {
					videoEnds(len - 1)
				} else {
					videoEnds(i - 1)
				}
			} else {
				video.muted = !video.muted
				vidWrapper.classList.toggle('muted')
			}
		})

		video.addEventListener('timeupdate', () => {
			if (heroVideos[i].classList.contains('next-video')) {
				span.innerHTML = 'Up Next'
			} else {
				let currentTime = video.currentTime
				let duration = video.duration
				span.innerHTML = `${Math.floor((duration - currentTime) / 60)}:${String(
					Math.floor((duration - currentTime) % 60)
				).padStart(2, '0')}`
			}
		})

		if (heroVideos[i].classList.contains('current-video')) {
			video.play()
		}

		video.addEventListener('ended', () => {
			videoEnds(i)
		})
	}

	function videoEnds(i) {
		const nextIndex = (i + 1) % len
		let currentVid = heroVideos[i].querySelector('video')
		currentVid.pause()
		currentVid.currentTime = 0

		// This should trigger if there is only one video
		// If that's the case, we just replay the video, no other changes are needed
		if (nextIndex === i) {
			currentVid.play()
			return
		}

		// Otherwise, we move on to the next video in the queue
		heroVideos[i].classList.remove('current-video')
		currentVid.load()

		heroVideos[nextIndex].classList.add('current-video')
		heroVideos[nextIndex].classList.remove('next-video')

		const nextvid = heroVideos[nextIndex].querySelector('video')
		nextvid.play()

		const nextx2 = (i + 2) % len
		heroVideos[nextx2].classList.add('next-video')

		let vidTime = heroVideos[nextx2].querySelector('.video-button')
		let span = vidTime.querySelector('span')

		if (heroVideos[nextx2].classList.contains('next-video')) {
			span.innerHTML = 'Up Next'
		}
	}
})
